import './styles/quasar.scss';
import '@quasar/extras/material-icons/material-icons.css';
import QLayout from 'quasar/src/components/layout/QLayout.js';import QHeader from 'quasar/src/components/header/QHeader.js';import QDrawer from 'quasar/src/components/drawer/QDrawer.js';import QPageContainer from 'quasar/src/components/page/QPageContainer.js';import QPage from 'quasar/src/components/page/QPage.js';import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';import QBtn from 'quasar/src/components/btn/QBtn.js';import QIcon from 'quasar/src/components/icon/QIcon.js';import QList from 'quasar/src/components/item/QList.js';import QItem from 'quasar/src/components/item/QItem.js';import QItemSection from 'quasar/src/components/item/QItemSection.js';import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';import QCard from 'quasar/src/components/card/QCard.js';import QCardSection from 'quasar/src/components/card/QCardSection.js';import QCardActions from 'quasar/src/components/card/QCardActions.js';import QMenu from 'quasar/src/components/menu/QMenu.js';import QSeparator from 'quasar/src/components/separator/QSeparator.js';import QForm from 'quasar/src/components/form/QForm.js';import QInput from 'quasar/src/components/input/QInput.js';import QAvatar from 'quasar/src/components/avatar/QAvatar.js';import QTable from 'quasar/src/components/table/QTable.js';import QTh from 'quasar/src/components/table/QTh.js';import QTr from 'quasar/src/components/table/QTr.js';import QTd from 'quasar/src/components/table/QTd.js';import QSpace from 'quasar/src/components/space/QSpace.js';import QSelect from 'quasar/src/components/select/QSelect.js';import Notify from 'quasar/src/plugins/notify/Notify.js';import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';import QTabs from 'quasar/src/components/tabs/QTabs.js';import QTab from 'quasar/src/components/tabs/QTab.js';import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';import QDate from 'quasar/src/components/date/QDate.js';import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';import QToggle from 'quasar/src/components/toggle/QToggle.js';import QFile from 'quasar/src/components/file/QFile.js';import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';import QTime from 'quasar/src/components/time/QTime.js';import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';import QSlider from 'quasar/src/components/slider/QSlider.js';import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';import Dialog from 'quasar/src/plugins/dialog/Dialog.js';import QRadio from 'quasar/src/components/radio/QRadio.js';import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';import QBanner from 'quasar/src/components/banner/QBanner.js';import QBadge from 'quasar/src/components/badge/QBadge.js';import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';;

export const quasarOptions = {
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QDialog,
    QCard,
    QCardSection,
    QCardActions,
    QMenu,
    QSeparator,
    QForm,
    QInput,
    QAvatar,
    QTable,
    QTh,
    QTr,
    QTd,
    QSpace,
    QSelect,
    QExpansionItem,
    QTabs,
    QTab,
    QTabPanel,
    QTabPanels,
    QDate,
    QPopupProxy,
    QToggle,
    QFile,
    QOptionGroup,
    QTime,
    QCheckbox,
    QSlider,
    QBtnDropdown,
    QRadio,
    QMarkupTable,
    QBanner,
    QBadge,
    QTooltip,
    QScrollArea,
  },
  directives: {
    ClosePopup,
    Ripple,
  },
  plugins: {
    Notify,
    Dialog,
  },
  config: {
    notify: {
      /* Notify defaults */
    },
  },
  extras: ['fontawesome-v5'],
  framework: {
    iconSet: 'fontawesome-v5',
  },
};
